import filterSearchClick, {
	DDC_INCENTIVE_FILTERSEARCH,
	DDC_INVENTORY_FILTERSEARCH_CLICK
} from '../../events/page/filterSearchClick';
import handleDynamicForms from './handleDynamicForms';
import getSelectorsToHandle from './selectorsToHandle';
import pushEvent from '../pushEvent';
import handleAjaxSuccess from './handleAjaxSuccess';
import handleTrackEvent from './handleTrackEvent';
import handleDDCEvent from './handleDDCEvent';

/*
	This section is for handling:
	$('body').on(event,selectors[selector],handler);
*/
const getDocumentOnHandlers = (
	win,
	{ dialog, form, link, page, slideshow }
) => ({
	click: [
		{
			selectorKey: 'formInitiation',
			handler: form.initiation
		},
		{
			selectorKey: 'formPaymentCalc',
			handler: form.paymentCalcInit
		},
		{
			selectorKey: 'formSubmission',
			handler: form.submission
		},
		{
			selectorKey: 'clickToCall',
			handler: link.clickToCall
		},
		{
			selectorKey: 'compareId',
			handler: link.compare
		},
		{
			selectorKey: 'incentiveId',
			handler: link.incentive
		},
		{
			selectorKey: 'getDirections',
			handler: link.getDirections
		},
		{
			selectorKey: 'linkClick',
			handler: link.clicked
		},
		{
			selectorKey: 'incentiveLabel',
			handler: link.clicked
		},
		{
			selectorKey: 'linksShareId',
			handler: link.share
		},
		{
			selectorKey: 'chatOpeners',
			handler: link.chatOpened
		},
		{
			selectorKey: 'navigationId',
			handler: link.navigationClick
		},
		{
			selectorKey: 'vehicleCompare',
			handler: link.vehicleCompare
		},
		{
			selectorKey: 'slideType',
			handler: slideshow.click
		},
		{
			selectorKey: 'socialHeaderButtonId',
			handler: link.socialHeader
		},
		{
			selectorKey: 'vin',
			handler: link.hproduct
		},
		{
			selectorKey: 'typedSearchInit',
			handler: page.typedSearchInit
		},
		{
			// MyCars save event
			selectorKey: 'mycarsSave',
			handler: link.mycarsSave
		},
		{
			// When Get Price Alerts is clicked
			selectorKey: 'mycarsGetAlerts',
			handler: link.mycarsGetAlerts
		},
		{
			// When compare checkbox is clicked
			selectorKey: 'mycarsCompare',
			handler: link.mycarsCompare
		},
		{
			// When compare button is clicked
			selectorKey: 'mycarsCompareSubmit',
			handler: link.mycarsCompareSubmit
		},
		{
			// When MyCars login form buttons are clicked
			selectorKey: 'mycarsLogin',
			handler: link.mycarsLogin
		},
		{
			// When global incentives facets are used
			selectorKey: 'incentiveFacet',
			handler: filterSearchClick.bind(
				undefined,
				DDC_INCENTIVE_FILTERSEARCH
			)
		},
		{
			// When vehicle search facets are used
			selectorKey: 'searchFacet',
			handler: filterSearchClick.bind(
				undefined,
				DDC_INVENTORY_FILTERSEARCH_CLICK
			)
		}
	],
	mousedown: [
		{
			selectorKey: 'linkClick',
			handler: link.centerClicked
		}
	],
	input: [
		{
			selectorKey: 'formInitiation',
			handler: form.initiation
		},
		{
			selectorKey: 'typedSearchInit',
			handler: page.typedSearchInit
		}
	],
	change: [
		{
			selectorKey: 'formChange',
			handler: form.change
		}
	],
	focusin: [
		{
			selectorKey: 'formPaymentCalc',
			handler: form.paymentCalcInit
		}
	],
	submit: [
		{
			selectorKey: 'formSubmission',
			handler: form.submission
		}
	],
	dialogopen: [
		{
			handler: dialog.opened
		}
	],
	'show.bs.modal': [
		{
			handler: dialog.opened
		}
	],
	slideOpen: [
		{
			handler: dialog.opened
		},
		{
			// When dialog/slidein is open and ready to interact with
			handler: dialog.ajaxContentLoaded
		},
		{
			// Capture forms on dynamically loaded content
			// ajaxDialogShown: htdocs/v9/media/js/ddc/v1/modules/dialog.js
			handler: handleDynamicForms.bind(undefined, win)
		}
	],
	dialogclose: [
		{
			handler: dialog.closed
		},
		{
			// // Strip out the `initiatingClickText` when a dialog is closed without being submitted
			handler: () =>
				localStorage?.removeItem('ddc_data_layer-initiatingClickText')
		}
	],
	'hide.bs.modal': [
		{
			handler: dialog.closed
		}
	],
	slideClose: [
		{
			handler: dialog.closed
		}
	],
	slidechange: [
		{
			handler: form.slideChange
		}
	],
	tabsshow: [
		{
			// Handle click events for jquery-ui tabs, because it doesn't bubble the normal event.
			handler: function handler(e, ui) {
				let eventObject;
				// import to note using regular function here and not arrow function as link.clicked needs 'this'
				if (ui?.tab) {
					eventObject = link.clicked.call(this, ui.tab, e);
				}
				return eventObject;
			}
		}
	],
	set: [
		{
			selectorKey: 'searchFacetVlpSlider',
			handler: filterSearchClick.bind(
				undefined,
				DDC_INVENTORY_FILTERSEARCH_CLICK
			)
		}
	],
	ajaxDialogComplete: [
		{
			// When dialog/slidein is open and ready to interact with
			handler: dialog.ajaxContentLoaded
		},
		{
			// Capture forms on dynamically loaded content
			// ajaxDialogShown: htdocs/v9/media/js/ddc/v1/modules/dialog.js
			handler: handleDynamicForms.bind(undefined, win)
		}
	],
	hproductClick: [
		{
			handler: link.hproduct
		}
	],
	slideshowPagerClick: [
		{
			handler: slideshow.pagerClick
		}
	],
	videoGalleryFacetBrowseChange: [
		{
			// this handles video gallery facet browse changes coming from v9/widgets/video/gallery/v2/js/widget.js
			// not sure why the $pageBody.on('change'... below is not noticing the DOM element changes
			handler: (_event, originalEvent) => form.change(originalEvent)
		}
	],
	'ddc-mega-menu-nav-ajax-load-complete': [
		{
			// Capture forms on dynamically loaded content
			// ajaxDialogShown: htdocs/v9/media/js/ddc/v1/modules/dialog.js
			handler: handleDynamicForms.bind(undefined, win)
		},
		{
			// "Temporary" (5 year old) solution for skipping event.preventDefault which sometime triggers from the
			// Adobe Tag Manager script causing mega menu forms to be submitted twice. :-(
			handler: ({ target }) => {
				$(target).on(
					'click submit',
					getSelectorsToHandle(win).formSubmission,
					async (event) => {
						const eventObjects = await form.submission(event);
						eventObjects?.forEach((eventObject) => {
							pushEvent(win, eventObject);
						});
					}
				);
			}
		}
	],
	ajaxDialogShown: [
		{
			// Capture forms on dynamically loaded content
			// ajaxDialogShown: htdocs/v9/media/js/ddc/v1/modules/dialog.js
			handler: handleDynamicForms.bind(undefined, win)
		}
	],
	ddcEvent: [
		{
			/*
			Generic listener so we can call DDC Events from other places.
			Must provide the eventType in the ddcEventData object.
			ex.
			{
				eventType: DDC.dataLayer.events.form.confirmation
			}

			we probably want to update this so that additional arguments can be
			passed to the called functions
		*/
			handler: handleDDCEvent
		}
	],
	ajaxSuccess: [
		{
			// Populate the DDC.dataLayer.myCars arrays
			handler: handleAjaxSuccess.bind(undefined, win)
		}
	],
	trackEvent: [
		{
			// handles trackEvent triggers so that we can use that data for generating DDC events
			handler: handleTrackEvent.bind(undefined, win)
		}
	]
});

export default getDocumentOnHandlers;
